<template>
  <card
    page="login"
    style="overflow:visible;">
    <label class="top-label">TERMS AND CONDITIONS</label>
    <form-component>
      <form
        id="terms-and-conditions"
        data-vv-scope="terms-and-conditions"
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <div class="col-12 terms-checkbox" >
          <input
            id="of_age"
            v-model="of_age"
            name="of_age"
            type="checkbox"
            v-validate="'required'"
          >
          <label class="form-check-label" for="of_age">
            I acknowledge that I am over the age of eighteen.
          </label>
        </div>
        <div class="col-12 terms-checkbox" >
          <input
            id="terms"
            v-model="terms"
            name="terms"
            type="checkbox"
            v-validate="'required'"
          >
          <label class="form-check-label" for="terms">
            I have read and accept BetterMynd's
            <a
              :href="`/docs/student_terms.pdf`"
              target="_blank"
              class="green"
            >
              Terms &amp; Conditions
            </a>
          </label>
        </div>
        <div
          v-if="$store.getters.currentUser.school"
          class="col-12 terms-checkbox" 
        >
          <input
            id="campus_consent"
            v-model="campus_consent"
            name="campus_consent"
            type="checkbox"
            v-validate="'required'"
          >
          <label class="form-check-label" for="campus_consent">
            I acknowledge that BetterMynd may share my credit usage, 
            session attendance, and anonymized demographics with my campus
          </label>
        </div>

        <div class="row mt-30">
          <div class="col-12 col-md-6 order-md-2">
            <button
              class="btn btn--primary mt-30"
              type="submit"
            >
              <span>Continue</span>
            </button>
          </div>
          <div class="col-12 col-md-6 order-md-1" />
        </div>
      </form>
    </form-component>
  </card>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import Card from '@/components/Card.vue';
export default {
  components: {
    Card,
    FormComponent
  },
  data(){
    return {
      terms: false,
      of_age: false,
      campus_consent: false,
    }
  },
  methods:{
    async save(){
      const result = await this.$validator.validateAll('terms-and-conditions');
      if (!result) {
        this.$store.commit('setGlobalAlert', {
          msg: "You must agree to all terms and conditions to use the BetterMynd application",
        });
        return; 
      }

      this.$emit('complete', null);
    }
  },
}
</script>

<style lang="scss" scoped>
.terms-checkbox {
  display:flex;
  margin-bottom:5px;
}
input[type=checkbox] {
  position: absolute;
  left: 20px;
  top: 5px;
  width: 20px;
  height: 20px;
}
input[type=checkbox] + label {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  font-size: 16px;
  line-height: 20px;
  margin: 5px;
}
input[type=checkbox] + label:before {
  line-height: 20px;
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  background-color: $blue;
  border: 1px solid $off-blue;
}
input[type=checkbox]:checked + label:before {
  content: "\2713";
  color: $green;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  cursor: pointer;
}
input[type=checkbox] + label:hover {
  cursor: pointer;
}
input[type=checkbox] + label:active:before {
  content: "\26F6";
  color: $off-blue;
  text-align: center;
  line-height: 16px;
}
</style>